export const RELEVANCE_INTERVAL = 600000
export const ERROR_CODE_SERVER = 418
export const ERROR_CODE_VALIDATION = 422
export const ERROR_CODE_NETWORK = 444
export const ERROR_MESSAGE_SERVER = 'Ошибка получения данных с сервера'
export const ERROR_MESSAGE_VALIDATION = 'Ошибка проверки формы данных'
export const ERROR_MESSAGE_NETWORK = 'Network Error'
export const ERROR_NAME_SERVER = 'ServerError'
export const ERROR_NAME_VALIDATION = 'ValidationError'
export const ERROR_NAME_NETWORK = 'NetworkError'
export const ERROR_NAME_CUSTOM = 'CustomError'
export const ERROR_CODE_BIDDING = 'e20201015'
export const MYME_TYPES = {
  ARRAYBUFFER: 'arraybuffer',
  CERTIFICATE: 'application/x-x509-ca-cert',
  FORM_DATA: 'multipart/form-data',
  OCTET_STREAM: 'application/octet-stream'
}
export const LOCAL_STORE_NAMES = {
  USER: 'user',
  LOCALE: 'locale',
  RELEVANCE: 'relevance'
}
